import API from "./api";

const API_URL = "/services";

export const getServices = async (society_id = "") => {
  try {
    const params = society_id ? { society_id } : {};
    const response = await API.get(API_URL, { params });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching services:", error);
    throw error;
  }
};

export const createService = async (serviceData) => {
  try {
    const response = await API.post(API_URL, serviceData);
    return response.data;
  } catch (error) {
    console.error("Error creating service:", error);
    throw error;
  }
};

export const updateService = async (id, serviceData) => {
  try {
    const response = await API.put(`${API_URL}/${id}`, serviceData);
    return response.data;
  } catch (error) {
    console.error("Error updating service:", error);
    throw error;
  }
};

export const deleteService = async (id) => {
  try {
    const response = await API.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting service:", error);
    throw error;
  }
};
